export default class AdvancedDestinationResults {
    constructor(advancedSelector, advancedSelectorContainer, advancedTabs) {
        this._advancedSelector = advancedSelector;
        this._advancedSelectorContainer = advancedSelectorContainer;
        this._noResultsItemClass = advancedTabs.noResultsItemClass;
        this._resultItemClass = advancedTabs.resultItemClass;
        this._resultItemSubtitleClass = advancedTabs.resultItemSubtitleClass;
        this._selectAll = advancedTabs.selectAll;
        this._tabsSelector = advancedTabs.tabsSelector;
        this._autocompleteField = advancedSelector._autocompleteField;
        this._mainInput = advancedSelector._mainInput;
        this._destinationCodeInput = advancedSelector._destinationCodeInput;
        this._selectMultipleHotelsDiv = document.querySelector('.roi-search-engine__destination-actions');
    }

    createNoResultsMessage() {
        const item = this._createBaseResult(this._advancedSelectorContainer.dataset.transNoResults);
        item.classList.add(this._noResultsItemClass);
        return item;
    }

    createResult(choice, category, subtitle = true) {
        const item = this._createBaseResult(choice.name);
        item.tabIndex = 0;
        item.dataset.code = choice.code;
        item.dataset.name = choice.name;
        item.dataset.category = category;
        if (this._shouldRenderCategory(choice)) {
            this._addCategoryToItem(item, choice.hotelCategory);
        }
        if (choice.city && subtitle) {
            this._addTextToItem(item, choice.city);
        }
        if (this._shouldRenderCheckbox(choice)) {
            this._addCheckboxToItem(item, choice.code);
        }
        return item;
    }

    _shouldRenderCategory(choice) {
        const hasCategoryFlag = this._advancedSelectorContainer
            .dataset.destinationWithCategory !== undefined;
        return hasCategoryFlag && choice.hotelCategory && choice.isHotel;
    }

    _shouldRenderCheckbox(choice) {
        return choice.isHotel && this._selectMultipleHotelsDiv;
    }

    listenToResultsEvents() {
        this._advancedSelectorContainer.querySelectorAll(`.${this._resultItemClass}`).forEach((item) => {
            if (item.classList.contains(this._noResultsItemClass)) {
                return;
            }
            item.addEventListener('keydown', (event) => {
                if (['ArrowUp', 'ArrowDown', 'Up', 'Down'].includes(event.key)) {
                    this._navigateResultsWithArrows(event);
                } else if (event.key === 'Tab') {
                    this._navigateFromResultToTab(event);
                } else if (event.key === 'Enter') {
                    event.preventDefault();
                    this._advancedSelector.selectChoice(item);
                }
            });
            item.addEventListener('click', (event) => {
                const clickedResult = event.target.closest(`.${this._resultItemClass}`);
                if (clickedResult && clickedResult !== item) {
                    return;
                }

                const checkbox = event.target.closest('.js-roi-search-engine-multiple-hotel-select');
                if (checkbox && checkbox.parentElement === item) {
                    this._addMultipleHotel(checkbox, item.dataset.code, item.dataset.name);
                } else {
                    this._advancedSelector.selectChoice(item);
                }
            });
        });

        const selectAll = this._advancedSelectorContainer.querySelector(`.${this._selectAll}`);
        if (selectAll) {
            selectAll.addEventListener('click', () => {
                this._advancedSelector.selectChoice(selectAll);
            });
        }
    }

    _splitRealLenght(text, separator) { // eslint-disable-line
        const textList = text.split(separator);
        if (textList[0] === '' && textList.length === 1) {
            return [];
        }
        return textList;
    }

    _addMultipleHotel(selectedCheckbox, itemCode, itemName) { // eslint-disable-line
        selectedCheckbox.classList.toggle('roi-search-engine__destination-multiselector--selected');
        const coddestino = document.getElementById('id_coddestino-widget-0');
        if (coddestino.value.startsWith('@')) {
            coddestino.value = '';
        }
        if (coddestino.value) {
            const existentValue = coddestino.value.indexOf(itemCode);
            if (existentValue < 0) {
                coddestino.value += `,${itemCode}`;
            } else if (existentValue === 0) {
                if (coddestino.value.startsWith(`${itemCode},`)) {
                    coddestino.value = coddestino.value.replace(`${itemCode},`, '');
                }
                coddestino.value = coddestino.value.replace(itemCode, '');
            } else {
                coddestino.value = coddestino.value.replace(`,${itemCode}`, '');
            }
        } else {
            coddestino.value += itemCode;
        }
        const hotelCount = this._splitRealLenght(coddestino.value, ',').length;
        if (hotelCount === 0) {
            this._clearCheckboxInput();
        } else if (hotelCount >= 1) {
            const translation = this._getMultipleHotelsSelectedTranslation();
            this._setMultipleChoices(hotelCount, translation, itemName);
        }
    }

    _getMultipleHotelsSelectedTranslation() { // eslint-disable-line
        let dataValue = '';
        if (this._selectMultipleHotelsDiv) {
            dataValue = this._selectMultipleHotelsDiv.dataset.transMultipleSelection;
        }
        return dataValue;
    }

    _clearCheckboxInput() {
        if (this._autocompleteField) {
            this._autocompleteField.value = '';
        }
        this._mainInput.value = '';
        this._advancedSelector.filterOptions();
    }

    _setMultipleChoices(hotelCount, translation, hotelName) {
        if (hotelCount === 1) {
            if (this._autocompleteField) {
                this._autocompleteField.value = hotelName;
            }
            this._mainInput.value = hotelName;
        } else {
            if (this._autocompleteField) {
                this._autocompleteField.value = `${hotelCount} ${translation}`;
            }
            this._mainInput.value = `${hotelCount} ${translation}`;
            const occupancyContainer = document.querySelector(
                '.js-roi-search-engine-occupancy-container'
            );

            if (occupancyContainer) {
                occupancyContainer.style.display = 'none';
            }
        }
    }

    _createBaseResult(textContent) {
        const item = document.createElement('li');
        item.classList.add(this._resultItemClass);
        item.innerText = textContent.trim();

        return item;
    }

    _getHotelIsSelected(hotelCode) { // eslint-disable-line
        const coddestino = document.getElementById('id_coddestino-widget-0');
        if (coddestino.value) {
            if (coddestino.value.includes(hotelCode)) {
                return true;
            }
        }
        return false;
    }

    _addCheckboxToItem(item, hotelCode) { // eslint-disable-line
        const checkBox = document.createElement('input');
        checkBox.type = 'checkbox';
        checkBox.classList.add('js-roi-search-engine-multiple-hotel-select');
        checkBox.classList.add('roi-search-engine__destination-multiselector');
        if (this._getHotelIsSelected(hotelCode)) {
            checkBox.classList.add('roi-search-engine__destination-multiselector--selected');
        }

        checkBox.addEventListener('click', (e) => {
            e.stopPropagation();
            this._addMultipleHotel(checkBox, item.dataset.code, item.dataset.name);
        });
        item.appendChild(checkBox);
    }

    _addCategoryToItem(item, categoryNumber) {  // eslint-disable-line
        const span = document.createElement('span');
        span.classList.add('roi-search-engine__destination-results-category');
        span.setAttribute('data-category', categoryNumber);
        item.appendChild(span);
    }

    _addTextToItem(item, textContent) {
        const span = document.createElement('span');
        span.classList.add(this._resultItemSubtitleClass);
        span.innerText = textContent;
        item.appendChild(span);
    }

    _navigateResultsWithArrows(event) {
        event.preventDefault();
        const result = event.currentTarget,
            index = +result.dataset.index,
            direction = ['ArrowUp', 'Up'].includes(event.key) ? -1 : 1,
            targetIndex = Math.max(0, index + direction),
            targetResult = this._advancedSelectorContainer.querySelector(
                `.${this._resultItemClass}[data-index='${targetIndex}']` +
                `[data-category=${result.dataset.category}]`
            );
        if (targetResult !== null) {
            targetResult.focus();
        }
    }

    _navigateFromResultToTab(event) {
        event.preventDefault();
        if (this._tabsSelector) {
            if (!event.shiftKey) {
                return;
            }
            this._advancedSelectorContainer.querySelector(
                `${this._tabsSelector}[data-target=${event.currentTarget.dataset.category}]`
            ).focus();
        }
    }
}
